import { Dns, Schema } from "../../../../../@types";
import Answers from "../Answers";
import { enums } from "../../../../../../../shim/jsbridge";
import Name from "../../../../../../search/schema/components/Name";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const dns: Schema<Dns> = {
  fields: [
    {
      name: "request",
      displayTitle: "Request",
      sortable: true,
      component: (d: Dns) => (
        <Name
          data={{
            file_name: d.request,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "answers",
      displayTitle: "Answers",
      sortable: true,
      component: (d: Dns) => <Answers answers={d.answers} />
    },
    {
      name: "post_lookup",
      displayTitle: "Post-Analysis Lookup",
      sortable: true,
      component: (d: Dns) => (
        <Name
          data={{
            file_name: d.post_lookup,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    }
  ]
};
